import { risksAPI } from "services/swagger-api/riskApi"
import { SubscriptionProcessSyncActions } from ".."
import { SubscriptionProcessState } from "../../types"
import { contractualizationStore } from "features/subscription-process/contractualization-process/store/contractualizationStore"
import { borrowerContractualizationStore } from "features/subscription-process/contractualization-process/store/borrowerContractualizationStore"
import {
  mapQuoteResponseToData,
  isQuoteContractualizationResponse
} from "features/subscription-process/contractualization-process/utils/mappers"
import { BorrowerContractualizationResponse } from "api/quote"

export const fetchSubscriptionProcess = async (
  riskId: string,
  actions: SubscriptionProcessSyncActions,
  getState: () => SubscriptionProcessState,
  quoteId?: string,
  borrowerProjectId?: string,
  /** Keeps the page on screen while loading (switch between the files of a group): no skeleton. */
  keepContent = false,
): Promise<void> => {
  try {
    if (!keepContent) {
      actions.setLoading(true)
    }
    actions.setError(null)

    if (borrowerProjectId) {
      // riskId ici est le borrowerId (emprunteurId)
      const borrowerId = riskId;
      const response = await risksAPI.getSubscriptionProcessBorrower({ projetEmpruntId: borrowerProjectId, emprunteurId: borrowerId, devisId: quoteId })

      if (response) {
        // Pour le flux borrower, le riskId est toujours le borrowerId (pas le borrowerProjectId)
        actions.initSubscriptionData({
          ...response,
          riskId: borrowerId
        })

        // Sync borrower data to borrowerContractualizationStore (single source of truth)
        if (response.contractualizationData) {
          borrowerContractualizationStore.actions.setBorrowerId(borrowerId)
          borrowerContractualizationStore.actions.setGlobalInfos(
            response.contractualizationData as BorrowerContractualizationResponse
          )
        }
      }
      return
    }

    const response = await risksAPI.getSubscriptionProcess({ riskId, devisId: quoteId })

    if (response) {
      // Ensure riskId is set even if backend doesn't return it
      const effectiveRiskId = response.riskId || riskId

      actions.initSubscriptionData({
        ...response,
        riskId: effectiveRiskId
      })

      // Sync quote data to contractualization store (single source of truth)
      if (isQuoteContractualizationResponse(response.contractualizationData)) {
        const mappedData = mapQuoteResponseToData(
          response.contractualizationData,
          effectiveRiskId,
          response.folderIdentifier,
          response.branchCode
        )
        contractualizationStore.actions.setQuoteData(mappedData)
      }
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : "Une erreur est survenue")
  } finally {
    actions.setLoading(false)
  }
}
